/**
 * Polyfills for the SM2 Angular CLI workspace.
 */

// Node globals required by transitive deps (jsrsasign / signalr / breeze).
// MUST run before any vendor module that references Buffer/process/global, hence
// these imports sit at the top of the polyfills entry.
import { Buffer } from 'buffer';
import * as process from 'process';
(window as any).global = window;
(window as any).Buffer = Buffer;
(window as any).process = process;

import 'core-js/proposals/reflect-metadata';
import 'zone.js';

// $localize is a global helper that the Angular compiler emits into component code.
// Even with no explicit i18n usage in source, transitive deps (devextreme-angular
// templates, etc.) call $localize at component-compile time, so it must be loaded
// before any module evaluates.
import '@angular/localize/init';
